import { render, staticRenderFns } from "./TheAddItemView.vue?vue&type=template&id=7a851074&scoped=true"
import script from "./TheAddItemView.vue?vue&type=script&lang=js"
export * from "./TheAddItemView.vue?vue&type=script&lang=js"
import style0 from "./TheAddItemView.vue?vue&type=style&index=0&id=7a851074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a851074",
  null
  
)

export default component.exports